<style lang="scss" scoped>
.equ{
  width: 415px;
  height: 198px;
  margin-top: 20px;
  cursor: pointer;
  .lifts{
    margin-top: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-evenly;
    .data{
      height: 92px;
      font-size: 18px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .number{
        font-size: 48px;
        font-family: 'dina';
      }
    }
    .data:nth-child(1){
      .number{
        color:#2D82FF;
      }
    }
    .data:nth-child(3){
      .number{
        color:#F1802F;
      }
    }
    
  }
}
</style>

<template>
  <div class="equ" @click="to('/equelevator')">
    <custom-plane title="电梯"
    :iconImg="require('@/assets/compImg/EquipmentIcon/lifts.png')">
    <div class="lifts">
        <div v-for="(item,index) in liftsList" :key="index" class="data">
            <p>{{item.title}}</p>
            <p class="number">{{item.num}}</p>
        </div>
    </div>
    </custom-plane>
  </div>
</template>

<script>
  export default {
    data(){
        return{
          
        }
      },
      props:{
        liftsList:Array
      },
      methods:{
        to(path){
          this.$router.push({path})
        }
      }
  };
  </script>
